import { render } from "./FirIndex.vue?vue&type=template&id=25993b92&scoped=true"
import script from "./FirIndex.vue?vue&type=script&lang=js"
export * from "./FirIndex.vue?vue&type=script&lang=js"

import "./FirIndex.vue?vue&type=style&index=0&id=25993b92&scoped=true&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25993b92"]])

export default __exports__